import React from "react";
import SettingsSection from "../SettingsSection";
import ChannelPicker from "../ChannelPicker";
import RolePicker from "../RolePicker";

const STAT_TYPES = [
  { value: "all", label: "All members (humans + bots)" },
  { value: "humans", label: "Humans only" },
  { value: "bots", label: "Bots only" },
  { value: "boosts", label: "Server boosts" },
  { value: "role", label: "Specific role count" },
];

const DEFAULT_FORMATS = {
  all: "👥 Members: {count}",
  humans: "☾ Members: {count}",
  bots: "🤖 Bots: {count}",
  boosts: "💎 Boosts: {count}",
  role: "🎭 Role: {count}",
};

function newStatId() {
  return `stat_${Date.now()}_${Math.random().toString(36).slice(2, 7)}`;
}

export default function SpiritCounterSection({
  channels,
  roles,
  serverStats,
  setServerStats,
  isOpen,
  setIsOpen,
}) {
  const updateStat = (id, patch) => {
    setServerStats(
      serverStats.map((stat) =>
        stat.id === id ? { ...stat, ...patch } : stat,
      ),
    );
  };

  const addStat = () => {
    setServerStats([
      ...serverStats,
      {
        id: newStatId(),
        channelId: "",
        type: "all",
        roleId: "",
        format: DEFAULT_FORMATS.all,
      },
    ]);
  };

  const removeStat = (id) => {
    setServerStats(serverStats.filter((stat) => stat.id !== id));
  };

  return (
    <SettingsSection>
      <p
        className="help-text"
        style={{ color: "#7b6f62", fontSize: "0.8rem", marginBottom: "15px" }}
      >
        Rename voice channels with live counts. Use <code>{"{count}"}</code> in
        the name format (it&apos;s added automatically if missing). Kami needs{" "}
        <strong>Manage Channels</strong> on those voice channels. Discord only
        allows about <strong>2 renames every 10 minutes</strong> — if a custom
        name doesn&apos;t appear right away, wait or save again after the
        cooldown; Kami also retries and updates on member join/leave.
      </p>

      {serverStats.map((stat) => (
        <div
          key={stat.id}
          style={{
            border: "1px solid rgba(123,111,98,0.25)",
            borderRadius: "10px",
            padding: "14px",
            marginBottom: "12px",
            background: "rgba(0,0,0,0.15)",
          }}
        >
          <label className="input-label">STAT TYPE</label>
          <select
            className="settings-input"
            value={stat.type}
            onChange={(e) => {
              const type = e.target.value;
              updateStat(stat.id, {
                type,
                format: DEFAULT_FORMATS[type] || stat.format,
                roleId: type === "role" ? stat.roleId : "",
              });
            }}
          >
            {STAT_TYPES.map((t) => (
              <option key={t.value} value={t.value}>
                {t.label}
              </option>
            ))}
          </select>

          {stat.type === "role" && (
            <>
              <label className="input-label">ROLE</label>
              <RolePicker
                roles={roles}
                value={stat.roleId || ""}
                onChange={(v) => updateStat(stat.id, { roleId: v })}
                emptyLabel="Select a role…"
                placeholder="Select a role…"
              />
            </>
          )}

          <label className="input-label">VOICE CHANNEL</label>
          <ChannelPicker
            channels={channels}
            value={stat.channelId || ""}
            onChange={(v) => updateStat(stat.id, { channelId: v })}
            kind="voice"
            emptyLabel="Select a voice channel..."
          />

          <label className="input-label">CHANNEL NAME FORMAT</label>
          <input
            className="settings-input"
            value={stat.format || ""}
            onChange={(e) => updateStat(stat.id, { format: e.target.value })}
            placeholder="Members: {count}"
          />

          <button
            type="button"
            className="btn btn-secondary"
            style={{ marginTop: "4px" }}
            onClick={() => removeStat(stat.id)}
          >
            Remove
          </button>
        </div>
      ))}

      <button type="button" className="btn btn-primary" onClick={addStat}>
        Add counter
      </button>
    </SettingsSection>
  );
}
